import moment from 'moment';

// const formatDate = (dateToFormat, format) => moment(dateToFormat).format(format);

// ie. May 1, 2016 (11:15 am) - LL - ie. December 25, 2016.
const parseDateTimeLocale = (localDateTime, ignoreDefaultTime) => (
  {
    datePart: localDateTime.format('ll'),
    timePart: (!ignoreDefaultTime && localDateTime.format('h:mm:ss') === '12:00:00') ?
      null : localDateTime.format('LT'),
  }
);

// If format is undefined, default to LL - ie. December 25, 2016
export const formati18nDate = (dateToFormat, language, format) => {
  const dateMoment = moment(dateToFormat);
  dateMoment.locale(language);
  return (
    {
      datePart: !dateToFormat ||
        (!format) ? dateMoment.format('ll')
        : dateMoment.format(format),
        timePart: null,
    }
  );
}

const parseI18nDateWithTime = (dateToFormat, language, ignoreDefaultTime) =>
  !dateToFormat || parseDateTimeLocale(moment.parseZone(dateToFormat).locale(language), ignoreDefaultTime);

export const getFormattedDateTime = (datetime, dateOnly, language, ignoreDefaultTime) =>
  (datetime ?
    parseI18nDateWithTime(datetime, language, ignoreDefaultTime) :
    formati18nDate(dateOnly, language, 'MMM YYYY'));

export const getMomenti18nDate = (dateToFormat, languageCode) => {
  moment.locale(languageCode);
  return moment(dateToFormat);
}

/* Secure Message Date Time - May 12, 2019 */

const parseTimeOnly = (dateToFormat, currTimeZoneOffset, language) => {
  const timeMoment = moment(dateToFormat);
  timeMoment.locale(language);
  return ({
    datePart: null,
    timePart: timeMoment.parseZone().utcOffset(currTimeZoneOffset).format('LT'),
  });
};

const parseMonthDayOnly = (dateToFormat, language) => {
  const mthDayMoment = moment(dateToFormat);
  mthDayMoment.locale(language);
  return (
    {
      datePart: !dateToFormat || mthDayMoment.format('MMM D'),
      timePart: null,
    }
  );
};



const parseMonthDayTime = (dateToFormat, currTimeZoneOffset, language) => {
  const datePartOnly = parseMonthDayOnly(dateToFormat, language);
  const timePartOnly = parseTimeOnly(dateToFormat, currTimeZoneOffset, language);
  return {
    datePart: datePartOnly.datePart,
    timePart: timePartOnly.timePart,
  };
};

const parseI18nDateTime = (dateToFormat, language, currTimeZoneOffset) => {
  const datePartOnly = formati18nDate(dateToFormat, language);
  const timePartOnly = parseTimeOnly(dateToFormat, currTimeZoneOffset, language);
  return {
    datePart: datePartOnly.datePart,
    timePart: timePartOnly.timePart,
  };
};

export const parseI18nDisplayDate = (dateToFormat, language, nowDate, currTimeZoneOffset, alwaysShowTime) => {
  const nowMoment = nowDate ? moment(nowDate) : moment();

  if (moment(dateToFormat).isSame(nowMoment, 'day')) {
    return parseTimeOnly(dateToFormat, currTimeZoneOffset, language);
  }
  if (moment(dateToFormat).isSame(nowMoment, 'year')) {
    return alwaysShowTime ? parseMonthDayTime(dateToFormat, currTimeZoneOffset, language)
      : parseMonthDayOnly(dateToFormat, language);
  }
  if (moment(dateToFormat).isBefore(nowMoment)) {
    return alwaysShowTime ? parseI18nDateTime(dateToFormat, language, currTimeZoneOffset)
      : formati18nDate(dateToFormat, language);
  }

  return dateToFormat;
};